import { render, staticRenderFns } from "./ad-suggest-dropdown-column.vue?vue&type=template&id=68fb9092"
import script from "./ad-suggest-dropdown-column.vue?vue&type=script&lang=ts"
export * from "./ad-suggest-dropdown-column.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports